import React from "react";
import { fileUrl } from "@/lib/api";
import { Modal, Badge } from "@/components/ui-kit";
import { Clock, Package, ListChecks, Dumbbell } from "lucide-react";

export default function ExerciseSheetModal({ exercise, onClose }) {
  if (!exercise) return null;
  const ex = exercise;
  return (
    <Modal open onClose={onClose} title={ex.name || "Exercice"}>
      <div className="space-y-4" data-testid="exercise-sheet">
        <div className="flex items-center gap-2 flex-wrap">
          {ex.theme && <Badge color="blue">{ex.theme}</Badge>}
          {ex.group && <Badge color="gray">{ex.group}</Badge>}
          {ex.duration ? <Badge color="green"><Clock size={12} /> {ex.duration} min</Badge> : null}
        </div>
        {ex.image && (
          <img src={fileUrl(ex.image)} alt={ex.name} className="w-full max-h-72 object-contain rounded-xl bg-white border border-border" />
        )}
        {ex.description && (
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-1 flex items-center gap-1.5"><Dumbbell size={13} className="text-primary" /> Explications</p>
            <p className="text-sm whitespace-pre-wrap leading-relaxed">{ex.description}</p>
          </div>
        )}
        {ex.tasks && (
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-1 flex items-center gap-1.5"><ListChecks size={13} className="text-primary" /> Consignes / tâches</p>
            <p className="text-sm whitespace-pre-wrap leading-relaxed">{ex.tasks}</p>
          </div>
        )}
        {ex.material && (
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-1 flex items-center gap-1.5"><Package size={13} className="text-primary" /> Matériel</p>
            <p className="text-sm whitespace-pre-wrap leading-relaxed">{ex.material}</p>
          </div>
        )}
        {!ex.description && !ex.tasks && !ex.material && !ex.image && (
          <p className="text-sm text-muted-foreground italic">Aucune explication détaillée pour cet exercice.</p>
        )}
      </div>
    </Modal>
  );
}
